import React from 'react';

const ACTIONS = [
  { key: 'save', label: 'Save Link', shortLabel: 'Save' },
  { key: 'share', label: 'Share', shortLabel: 'Share' },
  { key: 'pdf', label: 'Download PDF', shortLabel: 'Download' },
  { key: 'calendar', label: 'Add to Calendar', shortLabel: 'Calendar' },
];

const variantStyles = {
  subtle: {
    button: 'rounded-full border border-white/20 bg-white/5 text-white hover:bg-white/15',
    widthShort: 'w-[110px] md:w-[130px]',
    widthLong: 'w-[160px] md:w-[180px]',
    inner: 'text-xs md:text-sm font-semibold px-3 py-1.5',
  },
  primary: {
    button: 'btn-primary-cta inline-flex justify-center items-center rounded-lg shadow-xl shadow-emerald-900/20',
    widthShort: 'w-full md:w-48',
    widthLong: 'w-full md:w-52',
    inner: 'text-xs md:text-sm font-semibold px-0 py-0 whitespace-nowrap',
  },
};

const ItineraryActionsBar = ({
  className = '',
  labelMode = 'long',
  variant = 'subtle',
  actions: actionsProp,
  onAction,
  busyActionKey,
  busyLabel,
  disabledKeys = []
}) => {
  const actions = (Array.isArray(actionsProp) && actionsProp.length > 0 ? actionsProp : ACTIONS).map((action) => ({
    ...action,
    resolvedLabel: labelMode === 'short' ? action.shortLabel : action.label,
  }));

  const styles = variantStyles[variant] || variantStyles.subtle;
  const widthClass = labelMode === 'short' ? styles.widthShort : styles.widthLong;

  return (
    <div className={`flex flex-wrap items-center gap-2 md:gap-3 ${className}`.trim()}>
      {actions.map((action) => {
        const isBusy = busyActionKey === action.key;
        const isDisabled = isBusy || disabledKeys.includes(action.key);
        const label = isBusy && busyLabel ? busyLabel : action.resolvedLabel;

        return (
          <button
            key={action.key}
            type="button"
            className={`inline-flex justify-center transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-200 ${styles.button} ${widthClass} ${isDisabled ? 'opacity-60 cursor-not-allowed' : ''}`}
            onClick={() => {
              if (!isDisabled && onAction) onAction(action.key);
            }}
            disabled={isDisabled}
            aria-busy={isBusy}
          >
            <span className={`block text-center ${styles.inner}`}>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ItineraryActionsBar;
